module.exports = __webpack_public_path__ + "assets/img/5_1174_big.0d15724b.jpg";